//* Types
import { type ISaleOutputDTO } from "@/schemas/sales";

//* Helpers Imports
import { getSalePrice } from "@helpers/saleHelper";

type PaymentOrderDetailsProps = {
  sale: ISaleOutputDTO | null;
};

export function PaymentOrderDetails({ sale }: PaymentOrderDetailsProps) {
  const getProductName = (product: any) => {
    if (!product) return "Produto não encontrado";
    if (typeof product === "object") return product.name;
    const match = product.match(/name:\s*'([^']+)'/);
    return match ? match[1] : product;
  };

  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-clarotexto-202 text-xs font-semibold uppercase tracking-wider">
        Dados principais da venda
      </h2>
      <div className="h-px w-full bg-clarobordas-01" />

      <div className="flex flex-col gap-0.5">
        <span className="text-clarotextos-02 text-xs font-semibold">
          Produto
        </span>
        <span className="text-clarotexto-201 text-sm md:text-base font-medium">
          {sale ? getProductName(sale.productId) : "Carregando..."}
        </span>
      </div>

      <div className="h-px w-full bg-clarobordas-01" />

      <div className="flex flex-col gap-0.5">
        <span className="text-clarotextos-02 text-xs font-semibold">Valor</span>
        <div className="flex flex-col">
          {sale?.managerDiscount ? (
            <>
              <span className="text-xs text-gray-400 line-through">
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(getSalePrice(sale))}
              </span>
              <div className="flex items-center gap-2">
                <span className="text-clarotexto-201 text-sm md:text-base font-medium">
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(getSalePrice(sale) * (1 - sale.managerDiscount / 100))}
                </span>
                <span className="text-[10px] text-green-600 font-bold bg-green-50 px-1.5 py-0.5 rounded border border-green-100">
                  -{sale.managerDiscount}% OFF
                </span>
              </div>
            </>
          ) : (
            <span className="text-clarotexto-201 text-sm md:text-base font-medium">
              {sale
                ? new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(getSalePrice(sale))
                : "Carregando..."}
            </span>
          )}
        </div>
      </div>

      <div className="h-px w-full bg-clarobordas-01" />

      <div className="flex flex-col gap-0.5">
        <span className="text-clarotextos-02 text-xs font-semibold">
          Número do pedido
        </span>
        <span className="text-clarotexto-201 text-sm md:text-base font-bold uppercase tracking-tight">
          {sale ? sale.orderNumber : "..."}
        </span>
      </div>
    </section>
  );
}
